import { DialogTitle } from "@headlessui/react";
import CentsDialog from "../../../common/dialogs/Dialog";
import React, { useState } from "react";
import { TransactionRefund } from "../TransactionRefund";
import { translations } from "../../../../../utils/translations/translations-manager";
export function TransactionRefundDialog({ charityId, contractId, transactionId, visible, close, success }: { charityId: string, contractId: string, transactionId: string, visible: boolean, close: () => void, success: () => void }): JSX.Element {
  // Completed used to handle right closing the dialog after the change was successful as success
  const [completed, setCompleted] = useState(false)

  return <CentsDialog opened={visible} cancel={completed ? success : close}>
    <div className="flex flex-col items-center justify-center">
      <DialogTitle as="h3" className="text-base font-semibold text-gray-900 mb-6">
        {completed ? translations.texts.refund_transaction_success.toString() : translations.texts.refund_transaction.toString()}
      </DialogTitle>
      <TransactionRefund charityId={charityId} contractId={contractId} transactionId={transactionId} success={success} cancel={close} onCompleted={() => setCompleted(true)} />
    </div>
  </CentsDialog>
}